import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CredentialCreate } from "../models/credential/credential.create";

@Injectable()
export class CredentialBackend {
  constructor(private http: HttpClient) {}

  create(payload: CredentialCreate): Observable<Credential> {
    return this.http.post<Credential>(
      `${environment.snoots.api.iam}/credentials`,
      payload
    );
  }
}
